import {createFileRoute} from '@tanstack/react-router';
import {HomeLayout} from '@features/flow/components/HomeLayout';
import {InspirationView} from '@features/flow/components/InspirationView';

export const Route = createFileRoute('/inspiration')({
  component: InspirationPage,
});

function InspirationPage() {
  return (
    <HomeLayout currentView='inspiration'>
      <title>Banani | Inspiration</title>
      <InspirationView />
    </HomeLayout>
  );
}
